import { Injectable } from '@angular/core';

@Injectable()
export class ChartService {
  public constructor() {}

  getChartColors(count: number): Array<string> {
    const chartColors: Array<string> = ['#0675AA', '#549743', '#F1A01F', '#AC1E2D', '#7853A2', '#D2B132', '#2C2C2C'];
    let result = new Array<string>();

    if (count <= chartColors.length) result = chartColors.splice(0, count);
    else {
      let wholeArrays = Math.floor(count / chartColors.length);
      let remainder = count % chartColors.length;

      for (let i = 0; i <= wholeArrays; i++) {
        result.concat(chartColors);
      }

      result.concat(chartColors.splice(0, remainder));
    }

    return result;
  }
}
